import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'BACKGROUNDS'


const fields = [
  // 'AUTH_BACKGROUND',
  // 'ABOUT_BANNER',
  // 'APP_STORE_BACKGROUND',
  'CORE_BACKGROUND',
  // 'ANNOUNCEMENT_BANNER_BACKGROUND',
  // 'ANNOUNCEMENT_BANNER_BACKGROUND_MOBILE',
  'LANDING_HEADER_BACKGROUND',
  'BUSINESS_HEADER_BACKGROUND',
  'DEVICE_BACKGROUND',
  'CONTACT_US_BACKGROUND',
  'BOTTOM_ART',
  'PINAS_BACKGROUND',
  'PH_PIN',
  'LEFT_ACCENT',
  'RIGHT_ACCENT',
]

const formatLabel = value =>
  value
    .split('_')
    .join(' ')
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());

function Backgrounds({ getList, item, setFormData, createHidden, create, update, formData }) {
  const [imageLoading, setImageLoading] = useState({});
  const [imageError, setImageError] = useState({});
  const previousImageSources = useRef({});

  const getImageSource = field => {
    const fieldValue = _.get(formData, field);
    const cdnUrl = _.get(formData, `${field}.cdnUrl`) || _.get(fieldValue, 'cdnUrl') || _.get(fieldValue, 'url');

    if (_.isString(cdnUrl) && cdnUrl.trim()) {
      return cdnUrl;
    }

    if (_.isString(fieldValue) && fieldValue.trim()) {
      return fieldValue;
    }

    return '';
  };

  useEffect(() => {
    getList({ type: CMS_TYPE })
  }, [])

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id')
    })
  }, [item])

  useEffect(() => {
    const currentSources = fields.reduce((acc, field) => {
      acc[field] = getImageSource(field);
      return acc;
    }, {});

    const changedFields = fields.filter(
      field => previousImageSources.current[field] !== currentSources[field]
    );

    previousImageSources.current = currentSources;

    if (!changedFields.length) {
      return;
    }

    setImageLoading(prev => {
      const nextState = { ...prev };
      changedFields.forEach(field => {
        nextState[field] = !!currentSources[field];
      });
      return nextState;
    });

    setImageError(prev => {
      const nextState = { ...prev };
      changedFields.forEach(field => {
        nextState[field] = false;
      });
      return nextState;
    });
  }, [formData]);

  const handleOnSubmit = e => {
    e.preventDefault()

    if(_.get(formData, 'id')){
      return update(
        _.get(formData, 'id'),
        {
        body: JSON.stringify(_.pick(formData, fields))
      })
    }

    return create({
      body: JSON.stringify(_.pick(formData, fields))
    })
  }

  const onChangePhoto = key => value => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden(
            { key: 'id' },
            { placeholder: '' }
          )}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Background Library</h5>
              <p className="mb-0 text-muted">
                Upload and manage background assets.
              </p>
            </div>
          </div>
          <div className="row">
            {fields.map(field => {
              const imageSource = getImageSource(field);
              const hasImage = !!imageSource && !imageError[field];

              return (
                <div key={field} className="col-12 col-md-6 col-lg-4 mb-3">
                  <div className="border rounded bg-white shadow-sm p-3 mb-2">
                    <p className="form-label font-weight-bold text-center m-0 mb-2 mr-1">{formatLabel(field)}</p>
                    <div
                      className="d-flex justify-content-center align-items-center position-relative border rounded bg-light p-2 overflow-hidden"
                      style={{ minHeight: 180 }}
                    >
                      {imageLoading[field] && hasImage && (
                        <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                          <span className="fas fa-2x fa-spin fa-spinner text-info" />
                        </div>
                      )}
                      <img
                        className="img-fluid"
                        style={{
                          width: '100%',
                          maxWidth: 260,
                          maxHeight: 220,
                          objectFit: 'contain',
                          opacity: imageLoading[field] && hasImage ? 0 : 1
                        }}
                        alt={formatLabel(field)}
                        src={hasImage ? imageSource : ImagePlaceholder}
                        onLoad={() => setImageLoading(prev => ({ ...prev, [field]: false }))}
                        onError={() => {
                          setImageLoading(prev => ({ ...prev, [field]: false }));
                          setImageError(prev => ({ ...prev, [field]: true }));
                        }}
                      />
                    </div>
                    <FilePondSingleUpload onChange={onChangePhoto(field)} required={!hasImage} />
                  </div>
                </div>
              )
            })}
          </div>

          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              <span className="font-weight-bold">
                {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}


Backgrounds.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  // createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([withCmsForm, withRouter, connect(mapStateToProps, actions)]);

export default enhance(Backgrounds);
